const currentSurveyResultReducer = (state = [], action) => {
    switch (action.type) {
      case "SET_CURRENT_SURVEY_RESULT":
        return action.payload;
      default:
        return state;
    }
  }
  export default currentSurveyResultReducer;